import styled from '@emotion/styled';
import { colors } from '../../constants.js/colors';
import { Button } from '@material-ui/core';

export const Content = styled.div`
    padding: 40px 0;
    flex: 1;
    ${(props) => props.isActive && `opacity: 0.5;pointer-events: 'none'; `}
`;

export const ContentSubTitle = styled.div`
  flex: 1;
`;

export const ProgressBarContainer = styled.div`
    display: flex;
    align-items: center;
    margin-top: 1rem;
    gap: 1rem;
    & > p {
        white-space: nowrap;
        fonz-size: 0.75rem;
    }
`;

export const HomePageMobileContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    padding: 56px 20px 100px 20px;
    gap: 20px;
    background-color: ${colors.lightWhite};
`;

export const HomePageMobileFilterContainer = styled.div`
    position: relative;
    display: flex;
    width: 100%;
    gap: 12px;
    align-items: center;
`;

export const HomePageMobileCardContainer = styled.div`
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    padding: 8px;
    drop-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1);
    border-radius: 8px;
    background-color: ${colors.white};
`;

export const HomePageMobileCardIcon = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 56px;
    height: 56px;
    padding: 12px;
    border-radius: 100%;
    background-color: ${colors.primary.aquamarine}33;
`;

export const HomePageMobileOrderButton = styled(Button)`
    background-color: ${colors.primary.main};
    padding: 18px 8px;
    box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.1), 0px 4px 6px 0px rgba(0, 0, 0, 0.1);
`;

export const HomePageCardContainer = styled.div`
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    padding: 24px;
    drop-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1);
    border-radius: 8px;
    background-color: ${colors.white};
`;

export const HomePageProductViewsContainer = styled.div`
    display: flex;
    justify-content: space-between;
    width: 100%;
`;

export const HomePageDaysContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 4px;
`;

export const HomePageDayAchiveContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 40px;
    height: 40px;
    background-color: #e5e7eb;
    color: #4a4a4a;
    border-radius: 100%;
`;
